import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { InputLabel, MenuItem, FormControl, Select, makeStyles, GRAY } from '@applyboard/ui-components';
import InputLabelWrapper from "../InputLabelWrapper";
import LabelWrapper from "../LabelWrapper";
import ErrorMessage from "../ErrorMessage";
var useStyles = makeStyles({
  label: {
    top: '-5px'
  },
  icon: {
    right: '12px !important',
    color: "".concat(GRAY[5], "FF !important")
  }
});
var SelectComponentV2 = function SelectComponentV2(props) {
  var _props$error = props.error,
    error = _props$error === void 0 ? '' : _props$error,
    _props$extraLabelsFor = props.extraLabelsForTests,
    extraLabelsForTests = _props$extraLabelsFor === void 0 ? false : _props$extraLabelsFor,
    id = props.id,
    label = props.label,
    onBlur = props.onBlur,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? null : _props$onChange,
    options = props.options,
    _props$touched = props.touched,
    touched = _props$touched === void 0 ? true : _props$touched,
    value = props.value;
  var classes = useStyles();
  // Prevent "Material-UI: You have provided an out-of-range value `...` for the select component."
  // console warnings.
  var safeValue = React.useMemo(function () {
    return options.some(function (option) {
      return option.value.toString() === value;
    }) ? value : '';
  }, [options, value]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    onBlur: onBlur
  }, /*#__PURE__*/React.createElement(InputLabel, {
    "aria-label": extraLabelsForTests ? "".concat(id, " input label") : undefined,
    id: "".concat(id, "-outlined-label"),
    className: classes.label
  }, /*#__PURE__*/React.createElement(InputLabelWrapper, null, label)), /*#__PURE__*/React.createElement(Select, {
    "aria-label": extraLabelsForTests ? "".concat(id, " menu") : undefined,
    labelId: "".concat(id, "-outlined-label"),
    classes: {
      icon: classes.icon
    },
    id: extraLabelsForTests ? "".concat(id, "-outlined-select") : undefined,
    value: safeValue,
    onChange: onChange,
    label: extraLabelsForTests ? id : label,
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      getContentAnchorEl: null
    },
    IconComponent: ExpandMoreIcon
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: option.value,
      value: option.value
    }, /*#__PURE__*/React.createElement(LabelWrapper, null, option.label));
  }))), /*#__PURE__*/React.createElement("div", null, touched && error && /*#__PURE__*/React.createElement(ErrorMessage, {
    message: error
  })));
};
export default SelectComponentV2;